import { Component, computed, contentChild, ElementRef, Input, input, OnInit, Renderer2 } from '@angular/core';
import { InputErrorComponent } from '../input-error/input-error.component';
import { AbstractControl, FormControlName, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-input',
  standalone: true,
  imports: [InputErrorComponent],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss',
  host: {
    class: 'block input-group',
  },
})
export class InputComponent implements OnInit {
  @Input() type: string = 'text';
  noMargin = input(false);
  customErrors = input<ValidationErrors>();
  group = input<AbstractControl|null>();
  formControl = contentChild(FormControlName);
  controlName = computed(() => this.formControl()?.name as string);

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    if (this.noMargin()) {
      this.renderer.addClass(this.elementRef.nativeElement, 'no-margin');
    }
  }
}
